import React from 'react';
import css from 'styled-jsx/css';
import classnames from 'classnames';

import Subscription from './Subscription';

const STATUS = {
  DRAFT: 'DRAFT',
  CONFIRMED: 'CONFIRMED',
  ACTIVE: 'ACTIVE',
  TERMINATED: 'TERMINATED'
};

const subscriptionStyles = css`
  .subscriptions {
    margin: 0 0 40px;
    list-style: none;
    padding: 0;
  }
`;

const getTitle = (status, count) => {
  const firstPart = `Souscription${count > 1 ? 's' : ''}`;
  switch (status) {
    case STATUS.ACTIVE:
      return `${firstPart} en cours`;
    case STATUS.DRAFT:
      return `${firstPart} à confirmer`;
    case STATUS.CONFIRMED:
      return `${firstPart} à venir`;
  }
};

const Subscriptions = ({ className, subs, status, children }) => {
  const title = getTitle(status, subs.length);
  if (subs && subs.length > 0) {
    return (
      <>
        <h2 className={classnames('title', className)}>{title}</h2>
        <ul className="subscriptions">
          {subs.map(subscription => (
            <Subscription
              key={`profile-subscription-${subscription.id}`}
              subscription={subscription}
            >
              {children}
            </Subscription>
          ))}
        </ul>
        <style jsx>{subscriptionStyles}</style>
      </>
    );
  } else {
    return null;
  }
};

export default Subscriptions;
export { STATUS };
